/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductVariantDto } from '../../models/backend-product-variant-dto';

export interface SalesProductVariantsList$Params {
  /**
   * * `0` - Стандартная
   * * `1` - Расширенная
   */
  calculation_tab?: 0 | 1;
  create_date?: string;
  is_blocked?: boolean;

  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  project?: number;

  /**
   * A search term.
   */
  search?: string;
  variant_name?: string;
}

export function salesProductVariantsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesProductVariantsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendProductVariantDto>>> {
  const rb = new RequestBuilder(rootUrl, salesProductVariantsList.PATH, 'get');
  if (params) {
    rb.query('calculation_tab', params.calculation_tab, {});
    rb.query('create_date', params.create_date, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('ordering', params.ordering, {});
    rb.query('project', params.project, {});
    rb.query('search', params.search, {});
    rb.query('variant_name', params.variant_name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendProductVariantDto>>;
    }),
  );
}

salesProductVariantsList.PATH = '/api/sales/product_variants/';
